var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRotate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1765_76130)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.64216 2.95501C4.85187 1.90679 6.39949 1.33078 8.00016 1.33301C11.6822 1.33301 14.6668 4.31768 14.6668 7.99968C14.6668 9.42368 14.2202 10.7437 13.4602 11.8263L11.3335 7.99968H13.3335C13.3336 6.9541 13.0263 5.93155 12.4499 5.05919C11.8735 4.18682 11.0535 3.50312 10.0916 3.0931C9.12978 2.68307 8.06864 2.56482 7.04013 2.75303C6.01163 2.94124 5.06113 3.42761 4.30683 4.15168L3.64216 2.95501ZM12.3582 13.0443C11.1485 14.0926 9.60084 14.6686 8.00016 14.6663C4.31816 14.6663 1.3335 11.6817 1.3335 7.99968C1.3335 6.57568 1.78016 5.25568 2.54016 4.17301L4.66683 7.99968H2.66683C2.66674 9.04527 2.974 10.0678 3.55039 10.9402C4.12678 11.8125 4.94687 12.4962 5.90871 12.9063C6.87055 13.3163 7.93169 13.4345 8.96019 13.2463C9.9887 13.0581 10.9392 12.5717 11.6935 11.8477L12.3582 13.0443Z",
    fill: "#0A0903"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1765_76130"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotate);
export default __webpack_public_path__ + "static/media/rotate.1916cfca.svg";
export { ForwardRef as ReactComponent };